const Whistleblower = () => {
  return (
    <div className="whistle-container">
      <header>
        <h1>STATEMENT ON WHISTLEBLOWING</h1>
      </header>

      <main>
        <p>
          At Checkoff Finance Company Limited, we are committed to the highest standards of
          integrity, transparency and ethical conduct. Our Whistleblowing Policy provides a secure
          and confidential way for employees, vendors, customers and other stakeholders to report
          any form of wrongdoing, misconduct or unethical behaviour without fear of retaliation.
        </p>

        <p>
          We recognize that raising concerns takes courage. That’s why we ensure all whistleblowers
          are protected from victimization, harassment or any adverse consequences when reports are
          made in good faith. Whether it’s financial misconduct, data breaches, harassment, fraud or
          regulatory violations, we want you to feel confident that your voice will be heard, your
          concerns investigated and appropriate actions taken.
        </p>

        <h2>Key Highlights of Our Whistleblowing Policy:</h2>
        <ul>
          <li>
            <strong>Secure Reporting Channels:</strong> Multiple confidential avenues are available,
            including email contacts for Legal &amp; Compliance, Internal Audit and People Management.
          </li>
          <li>
            <strong>Protection Against Retaliation:</strong> We strictly prohibit any form of
            retaliation against whistleblowers and will investigate and address any such claims
            promptly.
          </li>
          <li>
            <strong>Anonymous Reporting Option:</strong> Reports can be made anonymously, and the
            company will respect confidentiality to the fullest extent permitted by law.
          </li>
          <li>
            <strong>Transparent Investigation Process:</strong> All concerns are acknowledged,
            reviewed and investigated impartially, with outcomes communicated where appropriate.
          </li>
        </ul>

        <p>
          By speaking up, you help protect our people, our customers and the integrity of Checkoff
          Finance Company Limited.
        </p>

        <h2>If you have any concerns, please contact us via the link below:</h2>
        <p>
          For anonymous reports, please{" "}
          <a href="https://docs.google.com/forms/d/e/1FAIpQLSe6YBxnihYyDBn7tNhYIo47Zngm_XAv9V2jLyWrha0LfHqeeA/viewform" target="_blank">click here</a>
        </p>

        <p>
          Together, we can uphold a culture of openness, accountability and ethical excellence.
        </p>
      </main>
    </div>
  );
};

export default Whistleblower;
